/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CrmError } from 'src/app/model/error';
import { ErrorProvider } from 'src/app/providers';

@Component({
  selector: 'error-details-modal',
  templateUrl: './error-details.modal.html',
  styleUrls: ['./error-details.modal.scss']
})

export class ErrorDetailsModal implements OnInit, OnDestroy {
  subject: Subject<boolean>;
  subscription: any;
  details: CrmError;
  comments: string;
  attachments: File[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private router: Router,
    private errorProvider: ErrorProvider
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') {
        this.onCancel();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onConfirm(): void {
    const body = {
      URL: this.details.URL,
      TYPE: this.details.TYPE,
      DATE: this.details.DATE,
      USER: this.details.USER.ID,
      MESSAGE: this.details.MESSAGE,
      COMMENTS: this.comments,
    };

    const formData: FormData = new FormData();
    formData.append('data', JSON.stringify(body));
    if (this.attachments.length > 0) {
      for (const f of this.attachments) {
        formData.append('files', f);
      }
    }

    this.errorProvider.sendError(formData)
      .subscribe(data => {
        if (data.success) {
          this.bsModalRef.hide();
          this.subject.next(true);
          this.subject.complete();
        }
      });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  onFileChanged(value: any): void {
    this.attachments = value != null ? value : null;
  }

}
